import Model from './cart/model';
import View from './cart/view';
import Controller from './cart/controller';
import updateCart from './cart/updateCart';

export default () => {
  const wrapper = document.querySelector('.js-cart');
  if (!wrapper) {
    return;
  }
  const model = new Model(wrapper.dataset.url);
  const view = new View(wrapper, updateCart);
  // eslint-disable-next-line no-new
  new Controller(model, view, wrapper);
};

export const initSpinner = () => {
  document.addEventListener('click', (e) => {
    const counterButton = e.target.closest('.js-spinner button');
    if (counterButton) {
      e.preventDefault();
      const qtyInput = counterButton.parentElement.querySelector('input');
      if (counterButton.classList.contains('js-spinner-btn-plus')) {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      }
      if (counterButton.classList.contains('js-spinner-btn-minus')) {
        qtyInput.value = parseInt(qtyInput.value, 10) <= 1 ? 1 : parseInt(qtyInput.value, 10) - 1;
      }

      const changeEvent = new Event('change');
      qtyInput.dispatchEvent(changeEvent);
    }
  });
};
